module.exports = __webpack_public_path__ + "img/police.00c28c37.png";